import { render, staticRenderFns } from "./GameItemContent.vue?vue&type=template&id=5fbc0300&scoped=true&"
import script from "./GameItemContent.vue?vue&type=script&lang=js&"
export * from "./GameItemContent.vue?vue&type=script&lang=js&"
import style0 from "./GameItemContent.vue?vue&type=style&index=0&id=5fbc0300&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc0300",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fbc0300')) {
      api.createRecord('5fbc0300', component.options)
    } else {
      api.reload('5fbc0300', component.options)
    }
    module.hot.accept("./GameItemContent.vue?vue&type=template&id=5fbc0300&scoped=true&", function () {
      api.rerender('5fbc0300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/parts/target/GameItemContent.vue"
export default component.exports